import { render, staticRenderFns } from "./SchoolEmployment.vue?vue&type=template&id=3715933d&scoped=true&"
import script from "./SchoolEmployment.vue?vue&type=script&lang=js&"
export * from "./SchoolEmployment.vue?vue&type=script&lang=js&"
import style0 from "./SchoolEmployment.vue?vue&type=style&index=0&id=3715933d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715933d",
  null
  
)

export default component.exports